var exports = {
  "Z": "AggregateLabels__j6RhSd",
  "P": "SanitizedHtml__dnxQKo",
};

module.exports = exports;
